/* Action Types */
export const LOAD_BIDDER_BIDDING_UPCOMING_FAIL = 'la/domain/bidderBiddingUpcoming/LOAD_FAIL';
export const LOAD_BIDDER_BIDDING_UPCOMING_REQUEST = 'la/domain/bidderBiddingUpcoming/LOAD_REQUEST';
export const LOAD_BIDDER_BIDDING_UPCOMING_SUCCESS = 'la/domain/bidderBiddingUpcoming/LOAD_SUCCESS';
